export default {
    id: null,
    search: null,
    role: 'ROLE_ERP',
    active: true
}
